import React from 'react';
import { motion } from 'framer-motion';
import { Loader } from 'lucide-react';

const DataTable = ({
  data = [],
  columns = [],
  loading = false,
  searchTerm = '',
  onSearchChange,
  statusFilter = '',
  onStatusChange,
  statusOptions = [],
}) => {
  if (loading) {
    return (
      <div className='responsive-card'>
        <div className='responsive-loading'>
          <div className='responsive-spinner' />
          <p>Loading data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className='content-section'>
      <div className='filters'>
        <input
          type='text'
          placeholder='Search...'
          className='search-input'
          value={searchTerm}
          onChange={(e) => onSearchChange?.(e.target.value)}
          style={{ flex: 1 }}
        />
        {statusOptions.length > 0 && (
          <select
            className='filter-select'
            value={statusFilter}
            onChange={(e) => onStatusChange?.(e.target.value)}
          >
            <option value=''>All Status</option>
            {statusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )}
      </div>

      <div className='table-container table-responsive'>
        <table className='data-table'>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <motion.tr
                key={row.id || index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ backgroundColor: 'rgba(255, 255, 255, 0.05)' }}
              >
                {columns.map((column) => (
                  <td key={column.key}>
                    {column.render ? column.render(row, index) : row[column.key]}
                  </td>
                ))}
              </motion.tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;
